import { render, staticRenderFns } from "./BlockThemes.vue?vue&type=template&id=39624c38&"
import script from "./BlockThemes.vue?vue&type=script&lang=js&"
export * from "./BlockThemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports